
<template>
  <div>
    <v-dialog v-model="dialog" persistent width="600px">
      <v-card>
        <v-card-title>
          <span v-if="!loading">Alteração data de vencimento da fatura #{{ this.$route.params.id }}</span>
          <span v-if="loading">Carregando...</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="pb-0">
          
          <card-loading-transparent v-if="loading || saving" :loadingText="loading ? 'Carregando' : 'Salvando'"></card-loading-transparent>
          <div v-if="!loading && !saving">
            <p class="my-0"><strong>Detalhes da fatura:</strong> {{ vrt_transaction.comment }}</p>
            <p class="my-0"><strong>Valor:</strong> {{ Number(vrt_transaction.ammount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</p>
            <p class="my-0"><strong>Valor pago:</strong> {{ Number(vrt_transaction.ammount_payed).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</p>
            <p class="my-0"><strong v-if="vrt_transaction.payment_description">Descrição da fatura</strong> {{ vrt_transaction.payment_description }}</p>
            
            <v-text-field class="mt-6" hide-details label="Data de vencimento:" readonly prepend-inner-icon="mdi-calendar" :value="$moment(vrt_transaction.DateExpired).format('LL')"></v-text-field>
            <v-form ref="form" class="pt-6">
              <v-date-picker
                v-model="vrt_transaction.DateExpired"
                full-width
                class="mt-4"
              ></v-date-picker>
            </v-form>
          
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn :disabled="loading || saving || vrt_transaction.DateExpired == aux_date" save @click="saveVrtTransaction" v-if="canUpdate"></f-btn>
          <f-btn close @click="$router.go(-1)" :disabled="saving"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'UpdateDateExpired',
  mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,
      loading: false,
      saving: false,
      vrt_transaction: {},
      date: '',
      aux_date: null,
    }
  },
  methods: {
    getVrtTransaction(){
      this.loading = true
      Api.VrtTransaction.show(this.$route.params.id).then((r) => {
        this.vrt_transaction = r.data.data.attributes
        this.aux_date = r.data.data.attributes.DateExpired
      }).catch(err=>{
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    saveVrtTransaction() {
      if(this.$refs.form.validate()){
        this.saving = true

        let vrt_transaction = {
          id: this.$route.params.id,
          DateExpired: this.vrt_transaction.DateExpired
        }

        Api.VrtTransaction.update(vrt_transaction).then(r=> {
          this.vrt_protest = r.data
          this.successSaved()
          this.$router.go(-1);
        }).catch(err=> {
          console.log(err.response.data?.errors[0])
          if (err.response.data?.errors[0]){
            this.addNotification({type: 'error', msg: err.response.data?.errors[0]})
          }else{
            this.errorCreated()
          }
        }).finally(() => {
          this.saving = false
        })
      }
    },
  },
  computed: {
    canUpdate(){
      return this.isSalesExecutive() || this.isDirector();
    },
  },
  mounted () {
    this.getVrtTransaction();
  },
}
</script>

<style scoped>

</style>